/* ============
 * productFlow Transformer
 * ============
 */

import Transformer from './transformer';

export default class ProductFlowTransformer extends Transformer {

  static fetch(productFlow) {
    return {
      id: productFlow.id,
      title: productFlow.title,
      orderId: productFlow.order_id,
      descriptions: productFlow.descriptions,
      productId: productFlow.product_id,
      qty: productFlow.qty,
      orderNumber: productFlow.order.number,
      productName: productFlow.product.name,
    };
  }

  static send(productFlow) {
    return {
      id: productFlow.id,
      title: productFlow.title,
      order_id: productFlow.orderId,
      product_id: productFlow.productId,
      descriptions: productFlow.descriptions,
      qty: productFlow.qty,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productFlow.js